var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('h1',{staticClass:"main-heading"},[_vm._v(_vm._s(_vm.folderName))]),_c('techpacks-list',{attrs:{"techpacks":_vm.techpacks,"loading":_vm.techpacksLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }